import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import Select from "react-select";

const VendorMasterEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Vendor "));
  }, []);

  const initialFormData = {
    Name: "",
    Email: "",
    Contact_No: "",
    IsInActive: 0,
    Address: "",
    Alternate_Number: "",
    ShopName: "",
    GSTNumber: "",
    PanNo: "",
     CountryType: 1,
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [vendorListData, setVendorListData] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(true);


  const countryOptions = [
    { value: 1, label: "Domestic" },

    { value: 2, label: "International" }
  ]
  useEffect(() => {
    fetchGetVendorMaster();
    if (id) {
      fetchShowVendorMaster(id);
    }
  }, []);

  const fetchGetVendorMaster = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}vendor-masters`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setVendorListData(cleanedData);
        setLoading(false);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

  const fetchShowVendorMaster = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}vendor-masters/${id}`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        const formDataEdit = {
          Address: cleanedData?.Address,
          Alternate_Number: cleanedData?.Alternate_Number,
          Contact_No: cleanedData?.Contact_No,
          Email: cleanedData?.Email,
          ID: cleanedData?.ID,
          IsInActive: cleanedData?.IsInActive,
          Name: cleanedData?.Name,
          RevisionNumber: cleanedData?.RevisionNumber,
          ShopName: cleanedData?.ShopName,
          GSTNumber: cleanedData?.GSTNumber,
          PanNo: cleanedData?.PanNo,
          CountryType:cleanedData?.CountryType
        };
        setFormData(formDataEdit);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

  const schema = Yup.object().shape({
    ShopName: Yup.string()
      .required("Vendor is required")
      .max(50, "Vendor cannot exceed 50 characters"),
    Name: Yup.string()
      .required("Contact Person is required")
      .max(50, "Contact Person cannot exceed 50 characters"),
    Email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    IsInActive: Yup.mixed(),
    Contact_No: Yup.string().matches(
      /^[0-9]{10}$/,
      "Contact Number must be a valid 10-digit number"
    ),
    Alternate_Number: Yup.mixed().nullable(),
    PanNo: Yup.string().when("CountryType", {
  is: (val) => String(val) === "1",  // ✅ ensures Domestic check
  then: (schema) =>
    schema
      .required("PAN No is required")
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN No"),
  otherwise: (schema) => schema.notRequired(),
}),

GSTNumber: Yup.string().when("CountryType", {
  is: (val) => String(val) === "1",  // ✅ ensures Domestic check
  then: (schema) =>
    schema
      .required("GST No is required")
      .matches(
        /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[0-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/,
        "Invalid GST Number format"
      ),
  otherwise: (schema) => schema.notRequired(),
}),

    Address: Yup.string().required("Address is required"),
    ReadyForBGV: Yup.string(),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Show error using toast for specific fields if needed
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // Check if the field exists in the schema
    if (schema.fields[name]) {
      // If the field exists in the schema, validate and update the form data
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData); // Trigger validation for the field
        return updatedData;
      });
    } else {
      // If the field does not exist in the schema, just store the data
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        return updatedData;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Validate formData using schema
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear previous errors

      // Call the API
      const response = await PostServiceCaller(
        `${API_URL}vendor-masters/${id}`,
        formData,
        "put"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          window.location.href = "/vendor-master";
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };


    if (pageLoading) {
      return (
        <>
          <p class="position-absolute top-50 start-50 translate-middle text-center">
            <FaSpinner class="spinner" />
          </p>
        </>
      );
    } else {
      return (
        <>
  <div className="Container">
              <form
                  id="formOne"
                className="rounded bg-white mt-2"
                onSubmit={handleSubmit}
              >
                <div className="p-2">
                  <div class="card-body  mx-2">
                    <div className="row">
                      <div className="col-md-2">
                        <label class="form-label">
                          Vendor<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.ShopName ? "is-invalid" : ""
                          }`}
                          name="ShopName"
                          onChange={(e) => handleChange(e)}
                          placeholder="Vendor"
                          value={formData.ShopName}
                        />{" "}
                        {errors.ShopName && (
                          <div className="invalid-feedback">{errors.ShopName}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label class="form-label">
                          Contact Person<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.Name ? "is-invalid" : ""
                          }`}
                          name="Name"
                          onChange={(e) => handleChange(e)}
                          placeholder=" Contact Person"
                          value={formData.Name}
                        />
                        {errors.Name && (
                          <div className="invalid-feedback">{errors.Name}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label class="form-label">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className={`form-control ${
                            errors.Email ? "is-invalid" : ""
                          } `}
                          name="Email"
                          onChange={(e) => handleChange(e)}
                          placeholder="Email"
                          value={formData.Email}
                        />
                        {errors.Email && (
                          <div className="invalid-feedback">{errors.Email}</div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <label class="form-label">
                          Contact No<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control ${
                            errors.Contact_No ? "is-invalid" : ""
                          }`}
                          name="Contact_No"
                          onChange={(e) => handleChange(e)}
                          placeholder="Contact No"
                          value={formData.Contact_No}
                        />
                        {errors.Contact_No && (
                          <div className="invalid-feedback">
                            {errors.Contact_No}
                          </div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <label class="form-label">Alternate Contact No</label>
                        <input
                          type="number"
                          className={`form-control `}
                          name="Alternate_Number"
                          onChange={(e) => handleChange(e)}
                          placeholder="Alternate Contact No"
                          value={formData.Alternate_Number}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                       <div className="col-md-2">
                    <label className="form-label">Country</label>
                    <Select
                      options={countryOptions}
                      name="CountryType"
                      onChange={(selectedOption) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          CountryType: selectedOption.value,
                        }))
                      }
                      value={countryOptions.find((o) => o.value === formData.CountryType)}
                    />



                  </div>
                      <div className="col-md-2">
                        <label class="form-label">
                          PAN No.{formData?.CountryType==1&&<span className="text-danger">*</span>}
                        </label>
                        <input
                          type="text"
                          className={`form-control  ${
                            errors.PanNo ? "is-invalid" : ""
                          }`}
                          name="PanNo"
                          onChange={(e) => handleChange(e)}
                          placeholder="PAN No"
                          value={formData.PanNo}
                        />
                        {errors.PanNo && (
                          <div className="invalid-feedback">{errors.PanNo}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label class="form-label">
                          GST No.{formData?.CountryType==1&&<span className="text-danger">*</span>}
                        </label>
                        <input
                          type="text"
                          className={`form-control  ${
                            errors.GSTNumber ? "is-invalid" : ""
                          }`}
                          name="GSTNumber"
                          onChange={(e) => handleChange(e)}
                          placeholder="GST No"
                          value={formData.GSTNumber}
                        />
                        {errors.GSTNumber && (
                          <div className="invalid-feedback">{errors.GSTNumber}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">
                          Address<span className="text-danger">*</span>
                        </label>
                        <textarea
                          placeholder="Address"
                          className={`form-control  ${
                            errors.Address ? "is-invalid" : ""
                          }`}
                          name="Address"
                          onChange={handleChange}
                          value={formData.Address}
                        ></textarea>{" "}
                        {errors.Address && (
                          <div className="invalid-feedback">{errors.Address}</div>
                        )}
                      </div>
                      <div className="col-4 mt-3 pt-1 d-flex">
                        <label className="form-label">Active</label>
                        <div>
                          <input
                            className="ms-2 form-check-input"
                            type="checkbox"
                            name="IsInActive"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsInActive === 1}
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: e.target.checked ? 1 : 0,
                                },
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="d-flex justify-content-end">
                        <div className="d-flex">
                          <div>
                            <button
                              type="button"
                              className="cancel-btn me-2"
                              onClick={() =>
                                (window.location.href = "/vendor-master")
                              }
                            >
                              Cancel
                            </button>
                          </div>
                          <div>
                            <button
                              disabled={loading ? true : false}
                              type="submit"
                              className="custom-btn"
                            >
                              {loading ? (
                                <FaSpinner class="sm-spinner" />
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            
          </div>
        </>
      );
    }
};

export default VendorMasterEdit;
